import { useQuery } from "@tanstack/react-query";
import type { QueryOpts } from "~api/helpers";
import type { TimeAccountsMeResponse } from "~generated";
import { TimeAccountsService } from "~generated";

export const timeAccountsKeys = {
  base: () => ["timeAccounts", "v2"] as const,
  me: () => [...timeAccountsKeys.base(), "me"] as const,
};

export function useTimeAccounts(
  options?: QueryOpts<
    TimeAccountsMeResponse,
    ReturnType<typeof timeAccountsKeys.me>
  >,
) {
  return useQuery({
    ...options,
    queryKey: timeAccountsKeys.me(),
    queryFn: () => TimeAccountsService.getMyTimeAccounts(),
  });
}
